(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-description-bottom"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-description-expand')) {
    class CollectionDescriptionExpand extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('data-condensed')) return;

        this.content = this.querySelector('[data-collection-description-content]');
        this.toggle = this.querySelector('[data-collection-description-toggle]');
        this.readMore = this.querySelector('[data-read-more]');
        this.readLess = this.querySelector('[data-read-less]');

        if (!this.content || !this.toggle) return;

        this.handleToggle = this.handleToggle.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.toggle.addEventListener('click', this.handleToggle);
        window.addEventListener('resize', this.handleResize, { passive: true });

        requestAnimationFrame(() => this.updateCondensedState());
      }

      disconnectedCallback() {
        this.toggle?.removeEventListener('click', this.handleToggle);
        window.removeEventListener('resize', this.handleResize);
      }

      handleToggle() {
        const expanded = this.getAttribute('data-expanded') === 'true';
        this.setExpanded(!expanded);
      }

      handleResize() {
        window.clearTimeout(this.resizeTimer);
        this.resizeTimer = window.setTimeout(() => this.updateCondensedState(), 120);
      }

      updateCondensedState() {
        const styles = getComputedStyle(this.closest('.collection-description-bottom'));
        const mobile = window.matchMedia('(max-width: 749px)').matches;
        const property = mobile
          ? '--collection-description-mobile-height'
          : '--collection-description-collapsed-height';
        const collapsedHeight = Number.parseFloat(styles.getPropertyValue(property));

        if (this.content.scrollHeight > collapsedHeight + 2) {
          this.classList.add('is-ready');
          this.toggle.hidden = false;
        } else {
          this.classList.remove('is-ready');
          this.toggle.hidden = true;
          this.setExpanded(false);
        }
      }

      setExpanded(expanded) {
        this.setAttribute('data-expanded', String(expanded));
        this.toggle.setAttribute('aria-expanded', String(expanded));
        this.readMore.hidden = expanded;
        this.readLess.hidden = !expanded;
      }
    }

    customElements.define('collection-description-expand', CollectionDescriptionExpand);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-list-toolbar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-index-toolbar')) {
    class CollectionIndexToolbar extends HTMLElement {
      connectedCallback() {
        this.initialize = this.initialize.bind(this);

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.initialize, { once: true });
        } else {
          this.initialize();
        }
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.initialize);
        this.sort?.removeEventListener('change', this.handleSort);
        this.densityButtons?.forEach((button) =>
          button.removeEventListener('click', this.handleDensity)
        );
      }

      initialize() {
        this.grid = document.querySelector('[data-testid="collections-list-grid"]');
        this.count = this.querySelector('[data-collection-count]');
        this.sort = this.querySelector('[data-collection-sort]');
        this.densityButtons = [...this.querySelectorAll('[data-collection-density]')];

        if (!this.grid) return;

        this.items = [...this.grid.querySelectorAll('.resource-list__item')];
        this.items.forEach((item, index) => {
          item.dataset.collectionOriginalIndex = String(index);
          item.dataset.collectionTitle = item.textContent.trim();
        });

        if (this.count) {
          this.count.textContent = `${this.items.length} collections`;
        }

        this.handleSort = this.handleSort.bind(this);
        this.handleDensity = this.handleDensity.bind(this);
        this.sort?.addEventListener('change', this.handleSort);
        this.densityButtons.forEach((button) =>
          button.addEventListener('click', this.handleDensity)
        );

        this.setDensity(this.dataset.defaultDensity || 'comfortable');
      }

      handleSort() {
        const mode = this.sort.value;
        const sorted = [...this.items];

        if (mode === 'title-ascending') {
          sorted.sort((a, b) =>
            a.dataset.collectionTitle.localeCompare(b.dataset.collectionTitle)
          );
        } else if (mode === 'title-descending') {
          sorted.sort((a, b) =>
            b.dataset.collectionTitle.localeCompare(a.dataset.collectionTitle)
          );
        } else {
          sorted.sort(
            (a, b) =>
              Number.parseInt(a.dataset.collectionOriginalIndex, 10) -
              Number.parseInt(b.dataset.collectionOriginalIndex, 10)
          );
        }

        sorted.forEach((item) => this.grid.append(item));
      }

      handleDensity(event) {
        this.setDensity(event.currentTarget.dataset.collectionDensity);
      }

      setDensity(density) {
        this.grid.dataset.collectionListDensity = density;
        this.densityButtons.forEach((button) => {
          button.setAttribute(
            'aria-pressed',
            String(button.dataset.collectionDensity === density)
          );
        });
      }
    }

    customElements.define('collection-index-toolbar', CollectionIndexToolbar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
